let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ijCL9")).then(() => parcelRequire('6sVCc'));